import geo from '@/store/modules/geo';
import layoutSolution from '@/store/modules/layout-solution';
import resultList from '@/store/modules/result-list';
import searchBar from '@/store/modules/search-bar';
import type { AppStore, AppStoreOptions } from '@/store/types';
import { createStore as _createStore } from 'vuex';

export const createStore = (options?: AppStoreOptions): AppStore =>
  _createStore({
    modules: {
      geo,
      resultList,
      searchBar,
      layoutSolution,
    },
    ...options,
  });
